import { CurrentUser, DeviceMeta, DisplayNames } from 'Roblox';
import groupModule from '../groupModule';

function groupController(
  $scope,
  $rootScope,
  $log,
  $location,
  modalService,
  groupsListService,
  groupDetailsService,
  groupsService,
  groupDetailsConstants,
  groupResources,
  groupUtilityService,
  systemFeedbackService,
  thumbnailConstants,
  $q,
  $uibModal,
  languageResource,
  groupsConstants,
  groupMembershipService,
  $document
) {
  'ngInject';

  function loadGroupData() {
    const whenLoadGroupData = $scope.loadGroup($scope.library.currentGroup.id);
    const whenReloadGroupsList = $scope.loadGroupsList(true);
    const whenLoadUserGroupMembership = $scope.loadGroupMembership($scope.library.currentGroup.id);

    return $q.all([whenLoadGroupData, whenReloadGroupsList, whenLoadUserGroupMembership]);
  }

  function closePopover() {
    // Click / outsideClick is the best trigger we can come up with for angular
    // bootstrap popover, but what that means is that clicking a menu element that
    // opens a modal leaves the menu open. This sends an outsideClick event to the
    // popover and forces it to close in a safe way, while still leveraging triggers.
    angular.element(document.querySelector('body')).click();
  }

  $scope.showModal = function (titleText, bodyText, actionButtonId) {
    return modalService.open({
      titleText,
      bodyText,
      actionButtonShow: true,
      actionButtonId,
      neutralButtonText: languageResource.get(groupDetailsConstants.translations.no)
    });
  };

  $scope.showLeaveGroupModal = function (groupId, userId) {
    closePopover();
    const modalParams = {
      animation: false,
      templateUrl: groupResources.modals.leaveGroup.templateUrl,
      controller: groupResources.modals.leaveGroup.controller,
      resolve: {
        modalData: {
          groupId,
          userId,
          isOwner: $scope.isCurrentUserOwner(),
          refreshGroupData() {
            loadGroupData();
          }
        }
      }
    };
    $uibModal.open(modalParams);
  };

  $scope.showReportAbuseModal = function (groupId) {
    closePopover();
    const reportAbuseTypes = groupDetailsConstants.reportAbuseName;
    if (!$scope.canViewStatus()) {
      delete reportAbuseTypes.shout;
    }
    const modalParams = {
      animation: false,
      templateUrl: groupResources.modals.reportAbuse.templateUrl,
      controller: groupResources.modals.reportAbuse.controller,
      resolve: {
        modalData: {
          groupId,
          roles: $scope.library.currentGroup.roles,
          reportAbuseTypes
        }
      }
    };
    $uibModal.open(modalParams);
  };

  $scope.cancelJoinRequest = function (groupId, userId) {
    groupMembershipService.cancelGroupJoinRequest(groupId, userId).then(
      function () {
        loadGroupData();
      },
      function () {
        systemFeedbackService.warning(
          languageResource.get(groupDetailsConstants.translations.defaultError)
        );
        $log.debug('--cancelJoinRequest-error---');
      }
    );
  };

  $scope.makePrimary = function (groupId) {
    closePopover();
    const modal = $scope.showModal(
      languageResource.get(groupDetailsConstants.translations.makePrimaryGroup),
      languageResource.get(groupDetailsConstants.translations.makePrimaryGroupWarning),
      groupDetailsConstants.makePrimaryActionButtonId
    );

    modal.result.then(function () {
      groupMembershipService.makePrimaryGroup(groupId).then(
        function () {
          // invoke $http calls from service to update data
          loadGroupData();
        },
        function () {
          systemFeedbackService.warning(
            languageResource.get(groupDetailsConstants.translations.makePrimaryError)
          );
          $log.debug('--makePrimary-error---');
        }
      );
    });
  };

  $scope.removePrimary = function () {
    closePopover();
    const modal = $scope.showModal(
      languageResource.get(groupDetailsConstants.translations.removePrimaryGroup),
      languageResource.get(groupDetailsConstants.translations.removePrimaryGroupWarning),
      groupDetailsConstants.removePrimaryActionButtonId
    );

    modal.result.then(function () {
      groupMembershipService.removePrimaryGroup().then(
        function () {
          // invoke $http calls from service to update data
          loadGroupData();
        },
        function () {
          systemFeedbackService.warning(
            languageResource.get(groupDetailsConstants.translations.removePrimaryError)
          );
          $log.debug('--removePrimary-error---');
        }
      );
    });
  };

  $scope.joinGroupCaptchaFailed = function () {
    systemFeedbackService.warning(
      languageResource.get(groupDetailsConstants.translations.joinGroupError)
    );
  };

  $scope.joinGroupCaptchaPassed = function (captchaData) {
    $scope.joinGroup(true, captchaData);
  };

  $scope.triggerCaptcha = function (dxBlob) {
    $scope.captchaReturnTokenInSuccessCb = true;
    $scope.captchaInputParams = { dataExchange: dxBlob };
    $rootScope.captcha.activated = true;
  };

  $scope.isCaptchaActive = function () {
    return $rootScope.captcha.activated;
  };

  $scope.joinGroup = function joinGroup(captchaPassed, captchaData) {
    if ($scope.isCaptchaActive() && !captchaPassed) {
      return;
    }

    groupMembershipService.joinGroup($scope.library.currentGroup.id, captchaData).then(
      function () {
        loadGroupData().then(
          function () {
            if ($scope.showJoinGroupButtonUI() === groupDetailsConstants.joinStatus.joinPending) {
              systemFeedbackService.success(
                languageResource.get(groupDetailsConstants.translations.joinGroupPendingSuccess)
              );
            } else {
              systemFeedbackService.success(
                languageResource.get(groupDetailsConstants.translations.joinGroupSuccess)
              );
            }
          },
          function () {
            // load failures have their own error feedbacks.
          }
        );
      },
      function (data) {
        if (data && data.errors && data.errors[0]) {
          const errorCode = data.errors[0].code;
          switch (errorCode) {
            case groupsConstants.errorCodes.membership.captcha:
              var dxBlob = data.errors[0].fieldData == null ? '' : data.errors[0].fieldData;
              $scope.triggerCaptcha(dxBlob);
              break;
            case groupsConstants.errorCodes.membership.operationUnavailable:
              systemFeedbackService.warning(
                languageResource.get(groupsConstants.translations.groupMembershipsUnavailableError)
              );
              break;
            default:
              systemFeedbackService.warning(
                languageResource.get(groupDetailsConstants.translations.joinGroupError)
              );
              $log.debug('--joinGroup-error---');
          }
        }
      }
    );
  };

  $scope.claimOwnership = function (groupId) {
    closePopover();
    groupMembershipService.claimOwnership(groupId).then(
      function () {
        systemFeedbackService.success(
          languageResource.get(groupDetailsConstants.translations.claimOwnershipSuccess)
        );
        loadGroupData();
      },
      function () {
        systemFeedbackService.warning(
          languageResource.get(groupDetailsConstants.translations.claimOwnershipError)
        );
        $log.debug('--claimOwnership-error---');
      }
    );
  };

  $scope.isCurrentUserOwner = function () {
    return (
      $scope.doesGroupHaveOwner() &&
      $scope.library.currentUser.id === $scope.library.currentGroup.group.owner.userId
    );
  };

  $scope.$on('$stateChangeSuccess', function (event, toState) {
    $scope.Data.activeTab = toState.name;
  });

  $scope.loadGroup = function (groupId) {
    return groupsService.getGroup(groupId).then(
      function (result) {
        if (result) {
          $scope.library.currentGroup.group = result;
          if (result.shout) {
            $scope.library.currentGroup.group.shout.shoutData = '';
          }
        }
      },
      function () {
        $scope.layout.loadGroupError = true;
        $log.debug('--loadGroup-error---');
      }
    );
  };

  $scope.doesShoutPosterExist = function () {
    return (
      $scope.library.currentGroup.group &&
      $scope.library.currentGroup.group.shout &&
      $scope.library.currentGroup.group.shout.poster &&
      $scope.library.currentGroup.group.shout.poster.userId > 0
    );
  };

  $scope.isLockedGroup = function () {
    return (
      $scope.library &&
      $scope.library.currentGroup &&
      $scope.library.currentGroup.group &&
      $scope.library.currentGroup.group.isLocked
    );
  };

  $scope.isGroupRestrictedByPolicy = function () {
    return (
      $scope.library &&
      $scope.library.currentGroup &&
      $scope.library.currentGroup.group &&
      $scope.library.currentGroup.group.isRestrictedByPolicy
    );
  };

  $scope.loadGroupsList = function (forceReload) {
    // Only attempt to load groups for authenticated users.
    if (!$scope.isAuthenticatedUser) {
      return;
    }

    // Only show loading indicator if the groups list is empty.
    $scope.library.groupsList.isLoadingGroups = !$scope.library.groupsList.groups;

    if (!$scope.library.groupsList.groups || forceReload) {
      return groupsListService
        .getGroups($scope.library.currentUser.id)
        .then(
          function (result) {
            $scope.library.currentUser.groupCount = result.length;
            $scope.library.groupsList.groups = result;
          },
          function () {
            $scope.library.groupsList.groups = [];
            $scope.library.groupsList.loadFailure = true;
            $log.debug('--loadGroupsList-error---');
          }
        )
        .finally(function () {
          $scope.library.groupsList.isLoadingGroups = false;
        });
    }
  };

  $scope.loadGroupMembership = function (groupId) {
    return $q(function (resolve, reject) {
      groupMembershipService.getGroupMembership(groupId).then(
        function (result) {
          if (result) {
            if (result.userRole) {
              $scope.library.currentGroup.role = result.userRole.role;
            }
            $scope.library.currentGroup.isPendingJoin = result.isPendingJoin;
            $scope.library.currentGroup.isPrimary = result.isPrimary;

            if (result.permissions) {
              $scope.library.currentGroup.permissions = result.permissions;
            }

            $scope.library.currentGroup.areGroupFundsVisible = result.areGroupFundsVisible;
            $scope.library.currentGroup.areEnemiesAllowed = result.areEnemiesAllowed;
            $scope.library.currentGroup.areGroupGamesVisible = result.areGroupGamesVisible;
          }
          resolve(result);
        },
        function (data) {
          $log.debug('--loadGroupMembership-error---');
          $scope.layout.loadGroupMembershipError = true;
          reject(data);
        }
      );
    });
  };

  $scope.loadGroupRoles = function (groupId) {
    // Fetch group roles
    groupsService.getGroupRoles(groupId).then(
      function success(result) {
        const { roles } = result;
        if (roles && roles.length > 1) {
          // Sort by rank (lowest to highest)
          roles.sort(function (a, b) {
            return a.rank - b.rank;
          });
          // Remove guest role (lowest rank)
          roles.shift();
          $scope.library.currentGroup.roles = roles;
        }
      },
      function () {
        systemFeedbackService.warning(
          languageResource.get(groupsConstants.translations.buildGroupRolesListError)
        );
        $log.debug('--getGroupRoles-error---');
      }
    );
  };

  $scope.getCurrencyIfNeeded = function () {
    if ($scope.library.currentGroup.areGroupFundsVisible) {
      $scope.loadGroupCurrency();
    }
  };

  $scope.sendGroupShout = function () {
    $scope.layout.isShoutSending = true;
    groupDetailsService
      .sendGroupShout(
        $scope.library.currentGroup.id,
        $scope.library.currentGroup.group.shout.shoutData
      )
      .then(
        function (result) {
          $scope.library.currentGroup.group.shout = result;
          $scope.library.currentGroup.group.shout.shoutData = '';
          $scope.layout.shoutInputFocused = false;
          $scope.layout.showShoutForm = false;
        },
        function () {
          $scope.layout.shoutError = languageResource.get(
            groupDetailsConstants.translations.sendGroupShoutError
          );
          $log.debug('--sendGroupShout-error---');
        }
      )
      .finally(function () {
        $scope.layout.isShoutSending = false;
      });
  };

  $scope.showShoutForm = function () {
    closePopover();
    if ($scope.canPostToStatus()) {
      $scope.$evalAsync(function () {
        $scope.layout.showShoutForm = true;
        $scope.layout.shoutError = null;
        $scope.layout.shoutInputFocused = true;
        $scope.layout.focusedElement = null;
      });
    }
  };

  $scope.blurShoutForm = function (evt) {
    if (evt?.target) {
      // do not blur the status form if we are clicking on the menu button or status text to reveal it.
      const { target } = evt;
      const targetId = target?.getAttribute('id') || target?.parentElement?.getAttribute('id');
      const unblurTargetIds = ['group-shout-text', 'send-group-shout-btn', 'group-shout'];
      if (targetId && unblurTargetIds.includes(targetId)) {
        return;
      }
    }

    $scope.$evalAsync(function () {
      // hide the form
      $scope.layout.showShoutForm = false;
      $scope.layout.shoutInputFocused = false;
    });
  };

  // Click outside the form
  angular.element($document).on('click touchstart', function (event) {
    const element = angular.element('#group-shout-form');
    if (element[0]) {
      if (element[0].contains(event.target)) {
        return;
      }
    }
    $scope.blurShoutForm(event);
  });

  $scope.loadGroupMetadata = function () {
    return $q(function (resolve, reject) {
      groupsService.getGroupMetadata().then(
        function (result) {
          if (result) {
            $scope.library.metadata = result;
          }
          $scope.library.metadata.isPhone = DeviceMeta && DeviceMeta().isPhone;
          $scope.library.metadata.isApp = DeviceMeta && DeviceMeta().isInApp;
          resolve(result);
        },
        function (data) {
          $log.debug('--loadGroupMetadata-error---');
          $scope.layout.loadGroupMetadataError = true;
          reject(data);
        }
      );
    });
  };

  $scope.loadGroupCurrency = function () {
    groupsService.getGroupCurrency($scope.library.currentGroup.id).then(
      function (robux) {
        $scope.currencyInRobux = robux;
      },
      function () {
        $log.debug('--loadGroupCurrency-error---');
      }
    );
  };

  $scope.isInGroup = function () {
    return (
      $scope.library.currentGroup.role &&
      $scope.library.currentGroup.role.id > 0 &&
      $scope.library.currentGroup.role.rank > 0
    );
  };

  $scope.canConfigureGroup = function () {
    return (
      $scope.library.currentGroup.permissions &&
      ($scope.library.currentGroup.permissions.groupMembershipPermissions.inviteMembers ||
        $scope.library.currentGroup.permissions.groupMembershipPermissions.removeMembers ||
        $scope.library.currentGroup.permissions.groupMembershipPermissions.changeRank ||
        $scope.library.currentGroup.permissions.groupManagementPermissions.manageRelationships ||
        $scope.library.currentGroup.permissions.groupManagementPermissions.viewAuditLogs ||
        $scope.library.currentGroup.permissions.groupEconomyPermissions.spendGroupFunds)
    );
  };

  $scope.doesGroupHaveOwner = function () {
    return (
      $scope.library.currentGroup.group &&
      $scope.library.currentGroup.group.owner &&
      $scope.library.currentGroup.group.owner.userId > 0
    );
  };

  $scope.isGroupPrimary = function () {
    return $scope.library.currentGroup.isPrimary;
  };

  $scope.showJoinGroupButtonUI = function () {
    // Content only valid if not in group yet
    if ($scope.isInGroup()) {
      return groupDetailsConstants.joinStatus.inGroup;
    }

    // Enforce group limits
    if ($scope.library.currentUser.groupCount >= $scope.library.metadata.groupLimit) {
      return groupDetailsConstants.joinStatus.maxGroups;
    }

    // Show pending if join was requested
    if ($scope.library.currentGroup.isPendingJoin) {
      return groupDetailsConstants.joinStatus.joinPending;
    }

    // Show group closed if no owner
    if (!$scope.doesGroupHaveOwner() && !$scope.library.currentGroup.group.publicEntryAllowed) {
      return groupDetailsConstants.joinStatus.groupClosed;
    }

    // No restrictions met
    return groupDetailsConstants.joinStatus.allowed;
  };

  $scope.canAdvertiseGroup = function () {
    return (
      $scope.library.currentGroup.permissions &&
      $scope.library.currentGroup.permissions.groupEconomyPermissions &&
      $scope.library.currentGroup.permissions.groupEconomyPermissions.advertiseGroup
    );
  };

  $scope.canViewWall = function () {
    return (
      $scope.library.currentGroup.permissions &&
      $scope.library.currentGroup.permissions.groupPostsPermissions &&
      $scope.library.currentGroup.permissions.groupPostsPermissions.viewWall &&
      $scope.policies.displayWall
    );
  };

  $scope.canPostToWall = function () {
    return (
      $scope.library.currentGroup.permissions &&
      $scope.library.currentGroup.permissions.groupPostsPermissions &&
      $scope.library.currentGroup.permissions.groupPostsPermissions.postToWall
    );
  };

  $scope.canViewStatus = function () {
    return (
      $scope.library.currentGroup.permissions &&
      $scope.library.currentGroup.group &&
      $scope.library.currentGroup.group.shout &&
      $scope.library.currentGroup.group.shout.body &&
      $scope.library.currentGroup.group.shout.poster &&
      $scope.library.currentGroup.group.shout.poster.userId > 0 &&
      $scope.library.currentGroup.permissions.groupPostsPermissions.viewStatus &&
      $scope.policies.displayShout
    );
  };

  $scope.canViewDescription = function () {
    return $scope.policies.displayDescription;
  };

  $scope.canViewMembers = function () {
    return $scope.policies.displayMembers;
  };

  $scope.canViewGroupRank = function () {
    return $scope.isInGroup() && $scope.policies.displayRank;
  };

  $scope.canPostToStatus = function () {
    return (
      $scope.library.currentGroup.permissions &&
      $scope.library.currentGroup.permissions.groupPostsPermissions &&
      $scope.library.currentGroup.permissions.groupPostsPermissions.postToStatus &&
      $scope.policies.displayShout
    );
  };

  $scope.profilePageUrl = function (userId) {
    return groupDetailsService.profilePageUrl(userId);
  };
  $scope.configureGroupUrl = function (groupId) {
    return groupDetailsService.configureGroupUrl(groupId);
  };
  $scope.advertiseGroupUrl = function (targetId) {
    return groupDetailsService.advertiseGroupUrl(targetId);
  };

  $scope.verifyGroupOrigin = function () {
    const groupId = $scope.library.currentGroup.id;
    groupsService.getGroupPolicyInfo([groupId]).then(
      function (response) {
        const isViewable =
          response &&
          response.groups &&
          response.groups[0] &&
          response.groups[0].canViewGroup === true;
        $scope.library.currentGroup.group.isRestrictedByPolicy = !isViewable;
      },
      function () {
        $log.debug('--checkGroupOrigin-error---');
        $scope.library.currentGroup.group.isRestrictedByPolicy = true;
      }
    );
  };

  $scope.loadGroupDetailPolicies = function () {
    if ($scope.library.metadata.isGroupDetailsPolicyEnabled) {
      groupsService.getGroupDetailRules().then(
        function (response) {
          $scope.policies = response;
          if ($scope.policies.checkGroupOrigin) {
            $scope.verifyGroupOrigin();
          }
        },
        function () {
          $log.debug('--loadGroupDetailPolicies-error---');
        }
      );
    } else {
      Object.keys(groupDetailsConstants.policies).forEach(item => {
        $scope.policies[item] = true;
      });
    }
  };

  $scope.init = function () {
    $scope.thumbnailTypes = thumbnailConstants.thumbnailTypes;
    $scope.relationshipTypes = groupsConstants.relationshipTypes;
    $scope.groupDetailsConstants = groupDetailsConstants;
    $scope.policies = $scope.groupDetailsConstants.policies;
    $scope.isAuthenticatedUser = CurrentUser.isAuthenticated;
    $scope.layout = {
      isDisplayNamesEnabled: DisplayNames.Enabled(),
      showShoutForm: false
    };
    $scope.library = {};

    $scope.library.moreGroupsUrl = groupsConstants.absoluteUrls.moreGroups;

    $scope.library.currentUser = {
      id: parseInt(CurrentUser.userId),
      groupCount: null,
      maxGroups: 0
    };

    $scope.library.currentGroup = {
      id: groupUtilityService.parseGroupId($location.absUrl()),
      group: {
        owner: null,
        shout: null
      },
      permissions: null,
      isPrimary: false,
      role: null,
      shoutIcon: null,
      isPendingJoin: false,
      isLocked: false,
      isRestrictedByPolicy: false
    };

    $scope.library.groupsList = {
      isLoadingGroups: false
    };

    $scope.library.metadata = {
      groupStatusMaxLength: 0,
      groupPostMaxLength: 0,
      isLoaded: false
    };
    $scope.currencyInRobux = null;

    $scope.loadGroup($scope.library.currentGroup.id);
    $scope.loadGroupsList();
    $scope.loadGroupRoles($scope.library.currentGroup.id);

    const membershipPromise = $scope.loadGroupMembership($scope.library.currentGroup.id);
    const metadataPromise = $scope.loadGroupMetadata();
    $q.all([membershipPromise, metadataPromise]).then(
      function () {
        $scope.layout.isLoadFinished = true;
        $scope.getCurrencyIfNeeded();
        $scope.loadGroupDetailPolicies();
      },
      function () {
        $log.debug('--error waiting for membershipPromise and metadataPromise---');
      }
    );
  };

  $scope.init();
}

groupModule.controller('groupController', groupController);
export default groupController;
